import { render, staticRenderFns } from "./addUsdt.vue?vue&type=template&id=4a7160cc&scoped=true&"
import script from "./addUsdt.vue?vue&type=script&lang=js&"
export * from "./addUsdt.vue?vue&type=script&lang=js&"
import style0 from "./addUsdt.vue?vue&type=style&index=0&id=4a7160cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7160cc",
  null
  
)

export default component.exports